<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToDateRange'
});
</script>
<template>
	<span ref="$el" :key="langKey" :flex="flex ? flex : null" class="to-date-range" :class="setClass">
		<span v-if="$slots.prefix" class="to-date-range-prefix">
			<slot name="prefix" />
		</span>
		<span v-if="props.prefix" class="to-date-range-prefix-text">
			<span>{{ props.prefix }}</span>
		</span>
		<input v-model="startDate" v-dis="disabled" class="to-date-range-input" :placeholder="startPlaceholder || t('to.daterange.startDate')" type="text" @focus="handleFocus" @keydown="handleInputKeydown" @beforeinput="handleBeforeInput" />
		<span class="to-date-range-separator">{{ props.seperatorText }}</span>
		<input v-model="endDate" v-dis="disabled" class="to-date-range-input" :placeholder="endPlaceholder || t('to.daterange.endDate')" type="text" @focus="handleFocus" @keydown="handleInputKeydown" @beforeinput="handleBeforeInput" />
		<to-icon v-if="startDate && endDate && props.clearable && !props.disabled" value="close" link class="to-date-range-clear" @click="handleClose"></to-icon>
		<span v-if="$slots.suffix" class="to-date-range-suffix">
			<slot name="suffix" />
		</span>
		<span v-if="props.suffix" class="to-date-range-suffix-text">
			<span>{{ props.suffix }}</span>
		</span>
		<to-icon :link="inputable" :value="props.icon" class="to-date-range-icon" @click="handleOpen"></to-icon>
		<Teleport to="body">
			<div class="to-date-range" :class="setClass">
				<to-float ref="floatRef" class="to-date-range-layer" :width="widthComputed" :global="false">
					<div class="to-date-range-calendars">
						<to-calendar v-model="rangeValue" class="to-date-range-calendar" :type="type" range :min="min" :max="max"></to-calendar>
						<span class="to-date-range-divider"></span>
						<to-calendar v-model="rangeValue" class="to-date-range-calendar" :type="type" range range-type="end" :min="min" :max="max"></to-calendar>
					</div>
				</to-float>
			</div>
		</Teleport>
	</span>
</template>
<script lang="ts" setup>
import { ToIcon, ToFloat, ToCalendar } from '@touchvue/components'
import { computed, ref, watch } from 'vue'
import { vDis } from '@touchvue/directives'
import { t, langKey } from '@touchvue/locale'



export interface DateRangeProps {
	modelValue?: string
	seperatorText?: string
	mode?: string
	icon?: string
	inputable?: boolean
	startPlaceholder?: string
	endPlaceholder?: string
	type?: string
	min?: string | Date | number
	max?: string | Date | number
	disabled?: boolean
	clearable?: boolean
	prefix?: string
	suffix?: string
	flex?: boolean
}

const props = withDefaults(defineProps<DateRangeProps>(), {
	modelValue: '',
	seperatorText: '~',
	mode: 'default',
	icon: 'date',
	inputable: true,
	startPlaceholder: '开始时间',
	endPlaceholder: '结束时间',
	type: 'date',
	min: '',
	max: '',
	disabled: false,
	clearable: true,
	prefix: '',
	suffix: '',
	flex: false
})

const floatRef = ref(null)
const $el = ref(null)
const startDate = ref('')
const endDate = ref('')
const rangeValue = ref('')

const emit = defineEmits(['update:modelValue', 'focus', 'change'])

const setClass = computed(() => {
	let classes = []
	if (props.mode) {
		classes.push(`mode-${props.mode}`)
	}
	return classes
})

const widthComputed = computed(() => {
	if (props.type === 'datetime') {
		return 80
	} else if (props.type === 'time') {
		return 23
	} else {
		return 50
	}
})

watch(
	() => props.modelValue,
	val => {
		console.log('props.modelValue === 83', val)
		if (val && val.includes(',')) {
			let arr = val.split(',')
			const start = arr[0]
			const end = arr[1]
			if (start && end) {
				startDate.value = start
				endDate.value = end
				rangeValue.value = val
			}
		} else {
			startDate.value = ''
			endDate.value = ''
			rangeValue.value = ''
		}
	},
	{ immediate: true }
)

watch(
	() => rangeValue.value,
	val => {
		console.log('rangeValue.value === 105', val)
		if (val) {
			let arr = val.split(',')
			const start = arr[0]
			const end = arr[1]
			if (start && end) {
				startDate.value = start
				endDate.value = end
				emit('change', val)
				emit('update:modelValue', val)
				floatRef.value.close()
			}
		} else {
			startDate.value = ''
			endDate.value = ''
			emit('change', '')
			emit('update:modelValue', '')
		}
	}
)
function handleFocus() {
	emit('focus', rangeValue.value)
	floatRef.value.open($el.value)
}
function handleInputKeydown(event: KeyboardEvent) {
	if (!props.inputable && event.key.length === 1) {
		event.preventDefault()
	}
}
function handleBeforeInput(event: InputEvent) {
	if (!props.inputable) {
		event.preventDefault()
	}
}
function handleOpen() {
	if (props.disabled) {
		return
	}
	floatRef.value.toggle($el.value)
}
function handleClose() {
	if (props.disabled) {
		return
	}
	startDate.value = ''
	endDate.value = ''
	rangeValue.value = ''
	emit('update:modelValue', '')
}
</script>
